import { Box, Typography, useMediaQuery } from "@mui/material";
import { colors } from "../../../../ui/colors";
import { useAppSelector } from "../../../../../redux/hooks/redux";
import { selectCurrentCompany, selectUser } from "../../../../../redux/features/user/selectors/userState.selectors";

export const CompanyInfo = () => {
  const user = useAppSelector(selectUser);
  const company = useAppSelector(selectCurrentCompany);

  const fullAddress =
    company?.address || company?.state || company?.zipCode
      ? `${company?.address ? company.address + ", " : ""}${company?.state ? company.state + ", " : ""}${company?.zipCode ? company.zipCode + ", " : ""}${company?.country || ""}`
      : "No address provided";

  const isXs = useMediaQuery("(max-width:600px)");
  return (
    <Box
      sx={{
        maxWidth: "250px",
        width: "100%",
        minHeight: "150px",
        textAlign: isXs ? "center" : "right",
        borderRadius: 3,
        px: 2,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography fontWeight={700} fontSize={18} mb={isXs ? 1 : 2}>
        Company Information
      </Typography>

      <Typography fontSize={14} color={colors.gray[800]} fontWeight={700}>
        {company?.businessName}
      </Typography>

      <Typography fontSize={14} color={colors.gray[600]}>
        Sender: {user.firstName} {user.lastName}
      </Typography>

      <Typography fontSize={14} color={colors.gray[600]}>
        {company?.businessEmail}
      </Typography>

      <Typography fontSize={14} color={colors.gray[600]}>
        {company?.businessPhone}
      </Typography>

      <Typography fontSize={13} color={colors.gray[600]}>
        {fullAddress}
      </Typography>
    </Box>
  );
};
